import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from 'axios'
import '../vue.config.js'
import * as ElIconModules from '@element-plus/icons'
import 'wow.js/css/libs/animate.css'
import { Vue } from 'vue-demi'
import Global from './assets/js/global.js'

const app = createApp(App)

app.config.globalProperties.$Global = Global
app.use(ElementPlus)
app.use(store).use(router).mount('#app')

for (const iconName in ElIconModules) {
    if (Reflect.has(ElIconModules, iconName)) {
      const item = ElIconModules[iconName]
      app.component(iconName, item)
    }
}

let getCookie = function (cookie) {
  let reg = /csrftoken=([\w]+)[;]?/g
  return reg.exec(cookie)[1]

}

// axios.interceptors.request.use(
//   function(config) {
//     // 在post请求前统一添加X-CSRFToken的header信息
//     let cookie = document.cookie;
//     if(cookie && config.method == 'post'){
//       config.headers['X-CSRFToken'] = getCookie(cookie);
//     }
//     return config;
//   },
//   function(error) {
//     // Do somng with request error
//     return Promise.reject(error);
// });

// Vue.prototype.$axios = axios
// axios.defaults.baseURL = '/api'
// axios.defaults.headers.post['Content-Type'] = 'application/json'